import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

const BASE_PATH = environment.basePath;

@Injectable({
  providedIn: 'root'
})
export class MasterBoPerfilAcessoService {

  constructor(private http: HttpClient) { }

  getIds(ids) {



    return this
     .http
     .post<any>(`${BASE_PATH}/bff/master-bo/users/create/profile/profiles/list`, ids)
     .toPromise();
  }
}
